import { motion, useReducedMotion } from "framer-motion";
import { MouseEventHandler, ReactNode } from "react";

interface LayoutNavigationTransitionProps {
  children: ReactNode;
  viewKey: string;
  className?: string;
  onClickCapture?: MouseEventHandler<HTMLDivElement>;
  focusContent?: (node: HTMLDivElement | null) => void;
}

export const LayoutNavigationTransition = ({
  children,
  viewKey,
  className,
  onClickCapture,
  focusContent,
}: LayoutNavigationTransitionProps) => {
  const shouldReduceMotion = useReducedMotion();
  const fadeDuration = shouldReduceMotion ? 0.12 : 0.4;

  return (
    <div className="gg-relative gg-w-full">
      <motion.div
        key={viewKey}
        ref={focusContent}
        className={className}
        onClickCapture={onClickCapture}
        tabIndex={-1}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: fadeDuration, ease: "easeInOut" }}
      >
        {children}
      </motion.div>
    </div>
  );
};
